import { FormControl, Input, InputLabel, InputProps } from "@mui/material";
import { forwardRef } from "react";
import { IMaskInput } from "react-imask";

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const DateTimeInput = forwardRef<HTMLInputElement, CustomProps>((props, ref) => {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="#000.00.00. 00:00:00"
      definitions={{
        "#": /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

type DateTimeFieldProps = InputProps & {
  label: string;
  shrink?: boolean;
  valid?: boolean;
};
export const DateTimeField = ({ label, shrink, onChange, valid = true, ...props }: DateTimeFieldProps) => {
  return (
    <FormControl variant="standard" fullWidth error={!valid}>
      <InputLabel htmlFor="formatted-text-mask-input" shrink={shrink}>
        {label}
      </InputLabel>
      <Input {...props} inputComponent={DateTimeInput as any} onChange={onChange} />
    </FormControl>
  );
};
